module.exports = __webpack_public_path__ + "img/takePhoto.fefe665e.png";